angular.module('bmsApp.directives')
	.directive('smVisitList', function (EmployeeSvc, ConfigService, $mdDialog) {


		return {
			restrict: 'E',
			scope: {
				ngModel: '=',
				disableEdit: '=',
				minutesUpdated: '&',
				removeAtIndex: '&',
			},
			templateUrl: 'ng/sm/directives/visitList/VisitList.html',
			link: function($scope, element, attrs, ngModel ) {
				$scope.showVisitNo = (attrs.showVisitNo == 'false') ? false : true;
				$scope.config = ConfigService.config;
				$scope.datePickerConfig = angular.copy($scope.config.datePicker.basic);
				$scope.timePickerConfig = angular.copy($scope.config.uiTimepickerOptions);
				$scope.timePickerConfig.appendTo = '.modal-body';

				if (attrs.isModal == "true") {
					angular.merge($scope.datePickerConfig, {
						options: {
							parentEl: '.modal-content'
						}
					});

					angular.merge($scope.timePickerConfig, {
						appendTo: '.modal-content'
					});
				}

				$scope.ctrl = {
					methods: {
						visitDateTimeOrDurationChanged: function (visit) {
							if(!visit.visit_date || !visit.visit_time){
								return;
							}
							var visitDateTime = visit.visit_date + ' ' + visit.visit_time.format('HH:mm:ss')
							var visitStartsAt = moment(visitDateTime).format('YYYY-MM-DD HH:mm:ss');
							var visitEndsAt = moment(visitDateTime).add(visit.duration_in_mins, 'minute').format('YYYY-MM-DD HH:mm:ss');
							var employeeParams = {
								filter: {
									availableOnDate: visit.visit_date,
									status: true,
									availableBetween: {
										startsAt: visitStartsAt,
										endsAt: visitEndsAt,
									},
								},
							};
							EmployeeSvc.index(employeeParams)
								.then(function (response) {
									angular.extend(visit, {
										employeesList: response.data.employee_collection
									});
								});
						},
						addEmployeeToVisit: function(visit) {
							visit.employees.push({});
						},
						visitEmployeeChanged: function(visit, employee) {
								// Check the visit doesn't already contain this employee
								var alreadyUsedCount = 0;
								angular.forEach(visit.employees, function (existingEmployee) {
									if (existingEmployee.id === employee.id) {
										alreadyUsedCount++;
									}
								});

								if (alreadyUsedCount > 1) {
									employee.id = null;
									$mdDialog.show(
										$mdDialog.alert()
											.clickOutsideToClose(true)
											.title('Can\'t set employee')
											.textContent('This employee is already assigned to the visit')
											.ariaLabel('employee')
											.ok('Okay')
									);
								}
								else {
									angular.extend(employee, {
										scheduled: true,
										actual: false
									})
								}
							}
						}
				};
			}
		};
	});

